const images = {
    Admin: require("assets/images/admin.png"),
    fallBack: require("assets/fallback.png"),
};

const studentLevelMapping = {
    beginner: 'beginners',
    experienced: 'experienced',
    expert: 'expert'
}

const onlineType = {
    online: "online",
    both: "both",
    offline: "offline",
}

const classType = {
    private: "private",
    group: "group",
}

const classCategory = {
    online: "Online",
    both: "In-Person/Online",
    offlinePrivate: "In-Person/Private",
    offlineGroup: "In-Person/Group",
}

export {images, studentLevelMapping, onlineType, classType, classCategory};

